"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Flagship = function Flagship(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "FlagshipTitle FlagshipDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "FlagshipTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "FlagshipDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M16.087 6.449a.449.449 0 0 0-.084.014L.743 11.849a.449.449 0 0 0 0 .855l5.99 2.118v8.022c0 .588.367 1.092.883 1.487s1.204.723 2.047.996c1.687.545 3.969.87 6.494.87s4.808-.325 6.494-.87c.843-.273 1.532-.6 2.047-.996.516-.395.884-.899.884-1.487v-8.022l5.386-1.908v5.204a.449.449 0 1 0 .897 0v-5.835a.449.449 0 0 0-.294-.434L16.31 6.463a.449.449 0 0 0-.224-.014zm.07.925l13.9 4.91-13.9 4.894-13.899-4.895 13.9-4.909zM7.63 15.13l8.373 2.96c.1.036.209.036.308 0l8.373-2.96v7.714c0 .216-.142.473-.533.772-.39.299-1.001.604-1.78.855-1.56.504-3.766.828-6.214.828-2.447 0-4.654-.324-6.213-.828-.78-.251-1.391-.556-1.781-.855-.39-.3-.533-.556-.533-.772V15.13z"
  }));
};

Flagship.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Flagship.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Flagship;
exports["default"] = _default;